import * as yup from 'yup';
import {
  ManagerTicketDetailsSchemaType,
  TicketCategorySchemaType,
  TicketDetailsSchemaType,
} from './types';

export const categorySchema: yup.ObjectSchema<TicketCategorySchemaType> =
  yup.object({
    category: yup.string().required(),
  });

export const ticketDetailsSchemaEmployee: yup.ObjectSchema<TicketDetailsSchemaType> =
  yup.object({
    issue: yup.string().required(),
    details: yup.string(),
    shareWithManager: yup.boolean().default(false),
    stayAnonymous: yup.boolean().default(false),
  });

export const ticketDetailsSchemaManager: yup.ObjectSchema<ManagerTicketDetailsSchemaType> =
  yup.object({
    employee: yup.string().required(),
    issue: yup.string().required(),
    details: yup.string(),
  });
